import { trigger, transition, style, animate } from '@angular/animations';

export const fadeInOut = trigger('fadeInOut', [
    transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms ease-in', style({ opacity: 1 }))
    ]),
    transition(':leave', [
        animate('500ms ease-out', style({ opacity: 0 }))
    ])
]);


export const saveButton = trigger('saveButton', [
    transition(':enter', [
        style({
            height: 0,
            opacity: 0,
            transform: 'scaleY(0)',
            transformOrigin: 'top'
        }),
        animate('300ms ease-out', style({
            height: '*',
            opacity: 1,
            transform: 'scaleY(1)'
        }))
    ]),
    transition(':leave', [
        animate('300ms ease-in', style({
            height: 0,
            opacity: 0,
            transform: 'scaleY(0)'
        }))
    ])
]);

export const desplegarAvall = trigger('desplegarAvall', [
    transition(':enter', [
        style({
            height: 0,
            opacity: 0,
            transform: 'scaleY(0)',
            transformOrigin: 'top'
        }),
        animate('300ms ease-out', style({
            height: '*',
            opacity: 1,
            transform: 'scaleY(1)'
        }))
    ]),
    transition(':leave', [
        animate('300ms ease-in', style({
            opacity: 0
        }))
    ])
]);

export const slideInOutHorizontal = trigger('slideInOutHorizontal', [
    transition(':enter', [
        style({
            transform: 'translateX(100%)',
            opacity: 0
        }),
        animate('1000ms ease-out', style({
            transform: 'translateX(0)',
            opacity: 1
        }))
    ]),
    transition(':leave', [
        animate('1000ms ease-in', style({
            transform: 'translateX(-100%)',
            opacity: 0
        }))
    ])
]);

export const slideInOutVertical = trigger('slideInOutVertical', [
    transition(':enter', [
        style({
            transform: 'translateY(-100%)',
            opacity: 0
        }),
        animate('1000ms ease-out', style({
            transform: 'translateY(0)',
            opacity: 1
        }))
    ]),
    transition(':leave', [
        animate('1000ms ease-in', style({
            transform: 'translateY(100%)',
            opacity: 0
        }))
    ])
]);